import React from 'react';
import { IconWarning } from '@americanexpress/dls-react';

const InvalidSupplier = () => (
  <div className="margin-responsive">
    <h1>Invalid Supplier <IconWarning /></h1>    
    <div className="new-line" />
    <h4>
        Unable to find supplier details or the supplier's profile has already been submitted!
    </h4>
  </div>
);

export default InvalidSupplier;
